import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Picture\AddPictureToDossierPictureController::__invoke
* @see app/Http/Controllers/Dossier/Picture/AddPictureToDossierPictureController.php
* @route '/api/dossier/{dossier}/picture/{collection_name}'
*/
const AddPictureToDossierPictureController = (args: { dossier: string | number | { id: string | number }, collection_name: string | number } | [dossier: string | number | { id: string | number }, collection_name: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddPictureToDossierPictureController.url(args, options),
    method: 'post',
})

AddPictureToDossierPictureController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/picture/{collection_name}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Picture\AddPictureToDossierPictureController::__invoke
* @see app/Http/Controllers/Dossier/Picture/AddPictureToDossierPictureController.php
* @route '/api/dossier/{dossier}/picture/{collection_name}'
*/
AddPictureToDossierPictureController.url = (args: { dossier: string | number | { id: string | number }, collection_name: string | number } | [dossier: string | number | { id: string | number }, collection_name: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            collection_name: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        collection_name: args.collection_name,
    }

    return AddPictureToDossierPictureController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{collection_name}', parsedArgs.collection_name.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Picture\AddPictureToDossierPictureController::__invoke
* @see app/Http/Controllers/Dossier/Picture/AddPictureToDossierPictureController.php
* @route '/api/dossier/{dossier}/picture/{collection_name}'
*/
AddPictureToDossierPictureController.post = (args: { dossier: string | number | { id: string | number }, collection_name: string | number } | [dossier: string | number | { id: string | number }, collection_name: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddPictureToDossierPictureController.url(args, options),
    method: 'post',
})

export default AddPictureToDossierPictureController